import {Injectable} from '@angular/core';
import {MedicalRecordPainModel} from '../../api/model/medicalRecordPain.model';
import {EntityCollectionServiceBase} from '@ngrx/data';
import {
    MedicalRecordVisitReasonRepository
} from '../../../visit-reason/impl/service/ngrx/medicalRecordVisitReason.repository';
import {AbstractDeleteOneService} from '../../../../../core/service/v2/service/delete/abstractDeleteOne.service';
import {MedicalPainRepository} from './ngxr/medicalPain.repository';
import {MedicalPainDataServiceAdapter} from './ngxr/medicalPainDataService.adapter';

@Injectable()
export class MedicalPainDeleteService extends
    AbstractDeleteOneService<MedicalRecordPainModel, MedicalRecordPainModel>{

    constructor(private service: MedicalPainRepository,
                public dataService: MedicalPainDataServiceAdapter,
                public visitReasonService: MedicalRecordVisitReasonRepository) {
        super(service, dataService);
    }

    protected getRepositoriesToSynchronize(): EntityCollectionServiceBase<any>[] {
        return [this.visitReasonService];
    }
}
